var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "menu-button",
    class: {
      'active': _vm.isActive
    },
    on: {
      "click": function ($event) {
        _vm.isActive = !_vm.isActive;
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]);
}
var staticRenderFns = []

export { render, staticRenderFns }